<template>
  <v-menu
    location="bottom"
    :theme="dropdownTheme"
  >
    <template #activator="{ props }">
      <v-btn
        v-bind="props"
        variant="text"
        class="main-nav-btn mx-1"
        size="small"
        :class="{ 'v-btn--active': isActive }"
      >
        <v-icon
          v-if="icon"
          class="mr-1"
          size="small"
        >{{ icon }}</v-icon>
        {{ label }}
        <v-icon
          class="ml-1"
          size="x-small"
        >mdi-menu-down</v-icon>
      </v-btn>
    </template>
    <v-list
      density="compact"
      min-width="180"
      :theme="dropdownTheme"
    >
      <v-list-item
        v-for="item in items"
        :key="item.to"
        :to="item.to"
        :prepend-icon="item.icon || undefined"
        :title="item.title"
        density="compact"
      ></v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  name: 'BaseMainNavMenu',

  props: {
    label: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      default: '',
    },
    items: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    dropdownTheme() {
      return this.$store.state.isDarkMode ? 'dark' : 'light';
    },

    isActive() {
      const path = this.$route.path;
      return this.items.some((item) => {
        if (!item.to) return false;
        return path === item.to || path.startsWith(`${item.to}/`);
      });
    },
  },
};
</script>
